import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useLang } from "../../lib/i18n";

export const DailyChart = ({ daily }) => {
  const { t } = useLang();
  return (
    <div className="rounded-3xl border border-slate-200/80 bg-white p-5" data-testid="insights-daily-chart">
      <div className="mb-4 flex flex-wrap items-center gap-4">
        <p className="me-auto font-display text-base font-bold text-slate-900">{t("ins_daily")}</p>
        <span className="flex items-center gap-1.5 text-xs text-slate-500"><span className="h-2.5 w-2.5 rounded-sm bg-[#262626]" />{t("ins_link_views")}</span>
        <span className="flex items-center gap-1.5 text-xs text-slate-500"><span className="h-2.5 w-2.5 rounded-sm bg-[#7EC9C9]" />{t("ins_qr")}</span>
      </div>
      <div dir="ltr" className="h-56">
        <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 320, height: 224 }}>
          <BarChart data={daily} margin={{ top: 4, right: 4, left: -16, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="#EEEEEE" />
            <XAxis dataKey="day" tickFormatter={(d) => d.slice(5)} tick={{ fontSize: 11, fill: "#94A3B8" }} tickLine={false} axisLine={false} minTickGap={16} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#94A3B8" }} tickLine={false} axisLine={false} />
            <Tooltip cursor={{ fill: "#F7F7F7" }} contentStyle={{ borderRadius: 12, border: "1px solid #E2E8F0", fontSize: 12 }} />
            <Bar dataKey="link_views" name={t("ins_link_views")} stackId="v" fill="#262626" />
            <Bar dataKey="qr_scans" name={t("ins_qr")} stackId="v" fill="#7EC9C9" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
